import { Avatar, AvatarShape, Column, Text } from 'farmhub-ui-core';

import { FlexAvatar } from 'components/Commons';
import { HeaderElectronicBillSkeleton } from 'components/Skeleton';
import {
  formatAppearPhoneNumber,
  formatImageUrl,
  getFullAddress,
  IMAGETYPE,
} from 'utils';

import { HeaderElectronicBillWrapper } from './styles';

type HeaderElectronicBillProps = {
  data: any;
  isLoading: boolean;
  isPrint?: boolean;
};

const HeaderElectronicBill = ({
  data,
  isLoading,
  isPrint = false,
}: HeaderElectronicBillProps) => {
  if (isLoading) {
    return <HeaderElectronicBillSkeleton />;
  }

  return (
    <HeaderElectronicBillWrapper>
      {data?.supplier?.avatar && (
        <FlexAvatar
          maxHeight="72px"
          src={formatImageUrl(data?.supplier?.avatar, IMAGETYPE.AVATAR.xs)}
        />
      )}
      <Column styles={{ gap: 2, height: '72px' }}>
        <Text color={isPrint ? 'black' : 'main'} size="sm" weight="bold">
          {data?.supplier?.displayName}
        </Text>
        <Text color={isPrint ? 'black' : 'secondary'} weight="bold">
          {getFullAddress(
            data?.supplier?.address,
            data?.supplier?.ward?.district?.fullName,
            data?.supplier?.ward?.province?.fullName,
            data?.supplier?.ward?.fullName
          )}
        </Text>
        <Text color={isPrint ? 'black' : 'secondary'} weight="bold">
          {formatAppearPhoneNumber(data?.supplier?.phoneNumber)}
        </Text>
      </Column>
    </HeaderElectronicBillWrapper>
  );
};

export default HeaderElectronicBill;
